import { SUBMISSION_STATUS_EMOJI_LABEL } from "encamp-shared/src/submissions";
import { SubmissionStatus } from "generated-graphql/graphql";

/**
 * Emoji-prefixed labels for submission statuses.
 * Re-exported from encamp-shared for convenience.
 */
export const STATUS_LABELS: Record<string, string> = SUBMISSION_STATUS_EMOJI_LABEL;

/**
 * Statuses where bulk add reviewers and bulk set signer actions are locked.
 * These submissions are too far in the workflow to allow reviewer/signer changes.
 */
export const BULK_ACTION_LOCKED_STATUSES: SubmissionStatus[] = [
  SubmissionStatus.EncampInitialReview,
  SubmissionStatus.InReview,
  SubmissionStatus.ProcessingSubmission,
  SubmissionStatus.FilingComplete,
];

/**
 * Checks if a submission status is locked for bulk reviewer/signer actions.
 */
export function isSubmissionLockedForBulkAction(
  status: SubmissionStatus | string | null | undefined
): boolean {
  if (!status) return false;
  return BULK_ACTION_LOCKED_STATUSES.includes(status as SubmissionStatus);
}
